const PULSING_VARIANTS = {
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  INFO: 'INFO',
  PAYMENT: 'PAYMENT',
}

export { PULSING_VARIANTS }
